import { Component, OnInit, Output, EventEmitter } from '@angular/core';

import { MapToolsService } from '../../../services/map-tools.service';
import { Gtp } from 'src/app/shared/gtp';

@Component({
  selector: 'app-tools-config',
  templateUrl: './tools-config.component.html',
  styleUrls: ['./tools-config.component.scss']
})
export class ToolsConfigComponent implements OnInit {

  tipoMapa:string = 'roadmap';
  tipoDePlan: any;

  event: Event;
  @Output() eventClicked = new EventEmitter<Event>();

  constructor(
    public MapToolsService: MapToolsService,
    private gtp: Gtp,
  ) {
    let user = JSON.parse(this.gtp.getUserData());
    //this.tipoDePlan = (user.cliente_plan_id == 1) ? "planBasico" : "planFull";
    //this.tipoDePlan = (user.cliente_plan_id == 3 ) ? "planBasico" : "planFull";
    switch (user.cliente_plan_id) {
      case 1:
        this.tipoDePlan = 1
      break;
      case 2:
        this.tipoDePlan = 2
      break;
      case 3:
        this.tipoDePlan = 3
        break;
      default:
        break;
    }
  }

  ngOnInit() {
    // Inicializar el tipo de mapa con el valor por defecto
    this.tipoMapa = this.MapToolsService.mapTypeId;
  }

  closeTab(event?: Event): void {
    this.eventClicked.emit(event);
  }

  toggleTraffic(event){
    this.MapToolsService.trafficLayer = event.checked;
    this.MapToolsService.setTrafficObs(event.checked);
  }

  toggleGeocercas(event){
    ///console.log(event)
    this.MapToolsService.cargaGeocercas = event.checked;
    this.MapToolsService.setCargaGeocercaObs(event.checked);
  }

  togglePuntos(event){
    //console.log(event)
    this.MapToolsService.cargaPuntos = event.checked;
    this.MapToolsService.setCargaPuntosObs(event.checked);
  }

  // Nuevos métodos para las funciones adicionales

  // Cambiar el tipo de mapa (roadmap, satellite, hybrid, terrain)
  changeMapType(tipo: string) {
    this.tipoMapa = tipo;
    this.MapToolsService.setMapTypeObs(tipo);
  }

  // Activar/desactivar mapa de calor
  toggleHeatmap(event) {
    this.MapToolsService.heatmapVisible = event.checked;
    this.MapToolsService.setHeatmapObs(event.checked);
  }

  // Activar/desactivar visualización de terreno
  toggleTerrain(event) {
    this.MapToolsService.terrainVisible = event.checked;
    this.MapToolsService.setTerrainObs(event.checked);
  }

  // Activar/desactivar herramienta de medición de distancia
  toggleMedicionDistancia(event) {
    // Si se activa la medición de distancia, desactivar la medición de área
    if (event.checked && this.MapToolsService.medicionArea) {
      this.MapToolsService.medicionArea = false;
      this.MapToolsService.setMedicionAreaObs(false);
    }
    this.MapToolsService.medicionDistancia = event.checked;
    this.MapToolsService.setMedicionDistanciaObs(event.checked);
  }

  // Activar/desactivar herramienta de cálculo de áreas
  toggleMedicionArea(event) {
    // Si se activa la medición de área, desactivar la medición de distancia
    if (event.checked && this.MapToolsService.medicionDistancia) {
      this.MapToolsService.medicionDistancia = false;
      this.MapToolsService.setMedicionDistanciaObs(false);
    }
    this.MapToolsService.medicionArea = event.checked;
    this.MapToolsService.setMedicionAreaObs(event.checked);
  }
}
